<script setup lang="ts">
  import { computed } from 'vue';
  import { type FlagName } from './Flag.types';

  interface FlagProps {
    name: `${FlagName}`;
  }
  const props = defineProps<FlagProps>();

  const symbolId = computed(() => `#icon-flag-${props.name}`);
</script>

<template>
  <svg class="flag" viewBox="0 0 28 28" aria-hidden="true">
    <use :href="symbolId" />
  </svg>
</template>

<style lang="scss" scoped>
  .flag {
    height: 28px;
    width: 28px;
  }
</style>
